import React, { useState } from "react";
import Icon from "../../../../../components/ui/Icon";

interface LinkedHeaderProps {
  id?: string;
  children: string;
  className?: string;
}

const LinkedHeader: React.FC<LinkedHeaderProps> = ({
  id,
  children,
  className = "",
}) => {
  const [showCheck, setShowCheck] = useState(false);

  const handleCopyLink = () => {
    if (!id) return;

    // Update URL with hash
    window.history.pushState(null, "", `#${id}`);

    // Copy link to clipboard
    const url = `${window.location.origin}${window.location.pathname}#${id}`;
    navigator.clipboard.writeText(url);

    // Show check icon temporarily
    setShowCheck(true);
    setTimeout(() => setShowCheck(false), 500);
  };

  return (
    <h2 id={id} className={`text-2xl group relative font-medium ${className}`}>
      {children}
      <button
        className="absolute opacity-0 group-hover:opacity-100 hover:opacity-100 transition-opacity outline-none focus:outline-none hidden md:block"
        style={{
          left: -32,
          top: 4,
        }}
        onClick={handleCopyLink}
      >
        <Icon className="text-2xl">{showCheck ? "check" : "link"}</Icon>
      </button>
    </h2>
  );
};

export default LinkedHeader;
